module.exports = __webpack_public_path__ + "img/loading.fe06f119.gif";